import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Avatar, AvatarFallback } from '../components/ui/avatar';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [visibleCount, setVisibleCount] = useState(6);

  const loadMore = () => {
    setVisibleCount(prev => prev + 3);
  };

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-nanny-cream">
      {/* Hero Section */}
      <section className="py-20 bg-nanny-cream">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-nanny-dark mb-6 heading-font">What Our Customers Say</h1>
            <p className="text-xl text-gray-700">
              Don't just take our word for it - hear from the families and businesses we've had the pleasure to serve
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto text-center">
            <div>
              <div className="text-4xl font-bold text-nanny-maroon mb-2">5.0</div>
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-nanny-accent text-nanny-accent" />
                ))}
              </div>
              <div className="text-gray-600">Average Rating</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-nanny-maroon mb-2">1000+</div>
              <div className="text-gray-600">Happy Customers</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-nanny-maroon mb-2">100%</div>
              <div className="text-gray-600">Homemade Quality</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {testimonials.slice(0, visibleCount).map((testimonial) => (
              <Card key={testimonial.id} className="hover:shadow-xl transition-all duration-300 hover:scale-105 border-2 border-transparent hover:border-nanny-maroon">
                <CardContent className="p-6">
                  {/* Stars */}
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 fill-nanny-accent text-nanny-accent" />
                    ))}
                  </div>
                  
                  {/* Testimonial Text */}
                  <p className="text-gray-700 mb-6 italic">"{testimonial.text}"</p>
                  
                  {/* Author Info */}
                  <div className="flex items-center">
                    <Avatar className="h-12 w-12 mr-4">
                      <AvatarFallback className="bg-nanny-maroon text-white font-semibold">
                        {getInitials(testimonial.name)}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <div className="font-semibold text-nanny-dark">{testimonial.name}</div>
                      <div className="text-sm text-gray-500">{testimonial.location}</div>
                      <div className="text-xs text-gray-400">{testimonial.date}</div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          
          {visibleCount < testimonials.length && (
            <div className="text-center mt-12">
              <button 
                onClick={loadMore}
                className="bg-nanny-maroon text-white px-8 py-3 rounded-lg hover:bg-nanny-dark transition-colors font-semibold"
              >
                Load More Reviews
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-nanny-maroon text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 heading-font">Become Our Next Happy Customer</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-nanny-cream">
            Experience the quality and taste that keeps our customers coming back for more
          </p>
          <a href="tel:731-267-9884">
            <button className="bg-white text-nanny-maroon px-8 py-4 rounded-lg hover:bg-nanny-cream transition-colors font-bold text-lg">
              Call 731-267-9884 Today
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
